import styled from "styled-components";
import { DESKTOP } from "../../../styles/breakpoints";
import { HomeContainer } from "../../../components/home-components/home-page.styled";

export const TalentPoolContainer = styled(HomeContainer)``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (min-width: ${DESKTOP}) {
    max-width: 1180px;
    margin: 0 auto;
  }
`;

export const DashboardHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const NotificationRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0.5rem;
`;

export const StatisticsRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0.5rem;
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
`;

export const Fit = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
`;

export const IconFit = styled.img`
  margin-right: 0.25rem;
  width: 1.5rem;
  height: 1.5rem;
`;

export const ValueFit = styled.span`
  font-weight: 700;
  color: #9d4faa;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin: 1rem;
  padding: 0;
`;
